<template>
  <div>
    <!-- <a-spin :spinning="loading"> -->
      <!-- :disabled="checkDisabled(setting) == true" -->
      <base-input :required="subSetting['required']" :label="subSetting['label']" :style="subSetting.style">
          <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
          <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
          <div v-if="subSetting.sub_type == 'multiple_select'">
              <a-select  
                          mode="multiple" style="width: 100%" placeholder="Please select" 
                          :filterOption="false"
                          :notFoundContent="fetching ? undefined : null" 
                          :value="valueToReturn"
                          :disabled="disabled"
                          @search="handleSearch"  
                          @change="handleChange">
                  <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                  <a-select-option v-for="option in filteredOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
              </a-select>
          </div>
          <div v-else>
            <a-select showSearch 
              style="width: 100%" placeholder="Please select" 
              :filterOption="false" 
              :notFoundContent="fetching ? undefined : null" 
              @search="handleSelectSearch" 
              :value="valueToReturn"
              :disabled="disabled"
              @focus="handleSelectSearch"
              @change="handleChange">
              <a-spin v-if="fetching" slot="notFoundContent" size="small" />
              <a-select-option v-for="option in filteredOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
            </a-select>
          </div>

      </base-input>
      <!-- </a-spin> -->
  </div>
</template>

<script>
  import HTTPRequest from '../controllers/httpRequest.js';
  import secureStorage from '../controllers/secureStorage.js';
  import { mapState } from 'vuex'

export default {
  props: ["value","subSettting","externalSelect"],
  computed: {
      ...mapState([ 'endPoint']),
  },
  mounted: async function(){ 

      this.subSetting = await this.$attrs.subSetting
      this.disabled = await this.$attrs.disabled
      this.filteredOptions = await this.subSetting["options"].slice().sort((a, b) => a.name.localeCompare(b.name));
      if(this.$attrs.existingValue){
        this.valueToReturn.id = await this.$attrs.existingValue
      }

      if(this.value && this.subSetting.sub_type !== 'multiple_select'){
        this.valueToReturn = this.value
      }

      console.log(this.valueToReturn)

    },
  data () {
      return {
          disabled: null,
          subSetting: {},
          valueToReturn: [],
          fetching: false,
          searchableSelectValue: null,
          filteredOptions: [],

          // loading: true
          
      }
  },
   watch: {
      searchableSelectValue: function (newValue) {
        this.handleSearch(newValue);
        console.log("MERON")
      },
      existingValue: async function(value){
        console.log("MERON 3")
      }
    },
  methods: {
      async handleSearch(value){
          this.fetching = true;
          if (this.subSetting.hasOwnProperty("endpoint")){
            this.filteredOptions.options = await HTTPRequest.getRequest(this.endPoint + this.subSetting.endpoint + "?name=" + value , null, null)   
          } else {
            this.filteredOptions = this.subSetting["options"].filter((option) =>
            option.name.toLowerCase().includes(value.toLowerCase())
          );
          }
          this.fetching = false;
      },
      async handleSelectSearch(value){
            this.fetching = true;
            let data
            if (this.subSetting.hasOwnProperty("endpoint")){
              if(value == undefined){
                  data = await HTTPRequest.getRequest(this.endPoint + this.subSetting.endpoint , null, null)
              }else {
                  data = await HTTPRequest.getRequest(this.endPoint + this.subSetting.endpoint + "?name=" + value , null, null)
              }
            }else{
              this.filteredOptions = this.subSetting["options"].filter((option) =>
              option.name.toLowerCase().includes(value.toLowerCase())
              );
            }

            if(data.data == undefined){
              this.filteredOptions = data
            }else{
              this.filteredOptions = data.data
            }

            this.fetching = false;
      },
      handleChange(value){
          this.valueToReturn = value
          this.$emit('updateValues', this.subSetting.code, this.valueToReturn)
      }
  }
  
}
</script>


<style>

</style>
